import React from 'react'

const CarbonOffset = () =>
  <div className="bg-light rounded-3 p-3">
    <p className="mb-0">
      Every crypto donation through Pledge will support verified carbon offset
      projects 🌏
    </p>
  </div>

export default CarbonOffset
